/** Joins class names, skipping what is missing: cx("sf-block", styles.readable, active && styles.active). */
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter((part): part is string => typeof part === "string" && part !== "").join(" ");
}
